import { Injectable } from '@angular/core';
import { CanLoad, Route, Router, UrlSegment } from '@angular/router';

import { Keys, PersistenceService } from '../services/persistence.service';

@Injectable({
  providedIn: 'root'
})
export class NewUserGuard implements CanLoad {

  constructor(
    private persistenceService: PersistenceService,
    private router: Router
  ) {
  }
  canLoad(route: Route, segments: UrlSegment[]): boolean {
    const user = JSON.parse(this.persistenceService.getValue(Keys.user));
    if (!user) {
      this.router.navigate(['/login']);
      return false;
    }

    if (user.complete) {
      return true;
    }

    this.router.navigate(['/update-password']);
    return false;
  }
}
